/**
 * Typed error hierarchy for API failures.
 * The Axios response interceptor maps every failure into one of these so call
 * sites can `instanceof`-check without parsing message strings.
 */

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
    public payload?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export class AuthError extends ApiError {
  constructor(message = 'Unauthorized', payload?: unknown) {
    super(401, message, payload);
    this.name = 'AuthError';
  }
}

export class NetworkError extends ApiError {
  constructor(message = 'Network error') {
    super(0, message);
    this.name = 'NetworkError';
  }
}

export class ValidationError extends ApiError {
  constructor(
    message: string,
    public fields: Record<string, string[]>,
  ) {
    super(422, message, fields);
    this.name = 'ValidationError';
  }
}

export class ForbiddenError extends ApiError {
  constructor(message = 'Forbidden') {
    super(403, message);
    this.name = 'ForbiddenError';
  }
}

export function isApiError(e: unknown): e is ApiError {
  return e instanceof ApiError;
}
